"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
// This file contains helper function to get the current navigation state of an
// interview and the status of the various sections for a given interview. To be
// updated when we update how navigation is stored.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIterationContextStarted = exports.isSectionCompleted = exports.getLastVisitedSection = void 0;
const helpers_1 = require("../../../utils/helpers");
/**
 * Get the last visited section from the interview object
 *
 * @param {Object} options - The options object
 * @param {UserInterviewAttributes} options.interview The interview object
 * @returns The last visited section
 */
const getLastVisitedSection = ({ interview }) => {
    const sectionActions = (0, helpers_1.getResponse)(interview, '_sections._actions', []);
    return sectionActions.length > 0
        ? {
            sectionShortname: sectionActions[sectionActions.length - 1].section,
            iterationContext: sectionActions[sectionActions.length - 1].iterationContext
        }
        : undefined;
};
exports.getLastVisitedSection = getLastVisitedSection;
/**
 * Get whether a section is marked as completed or not
 *
 * @param {Object} options - The options object
 * @param {UserInterviewAttributes} options.interview The interview
 * object
 * @param {string} options.section The name of the section to check
 * @param {string[]} [options.iterationContext] The specific iteration context
 * to check if the section is part of a repeated block
 * @returns Whether the section is marked as completed
 */
const isSectionCompleted = ({ interview, sectionName, iterationContext }) => {
    const sectionPath = iterationContext ? `${sectionName}.${iterationContext.join('/')}` : sectionName;
    const sectionStatus = (0, helpers_1.getResponse)(interview, `_sections.${sectionPath}`, {});
    return sectionStatus._isCompleted === true;
};
exports.isSectionCompleted = isSectionCompleted;
/**
 * Check if the iteration context has started for a given interview. It will
 * return true if any section for that iteration context has started.
 *
 * @param {Object} options - The options object
 * @param {UserInterviewAttributes} options.interview The interview object
 * @param {string[]} options.iterationContext The iteration context to check
 * @returns Whether the iteration context has started
 */
const isIterationContextStarted = ({ interview, iterationContext }) => {
    if (iterationContext.length === 0) {
        return true;
    }
    const iterationString = iterationContext.join('/');
    const sectionsStatus = (0, helpers_1.getResponse)(interview, '_sections', {});
    return Object.keys(sectionsStatus).some((sectionName) => {
        const sectionStatus = sectionsStatus[sectionName];
        return sectionStatus[iterationString] !== undefined && sectionStatus[iterationString]._startedAt !== undefined;
    });
};
exports.isIterationContextStarted = isIterationContextStarted;
//# sourceMappingURL=navigationHelpers.js.map